<script lang="ts">
  import { Icon } from '$shared/components';
  import type { XFile } from '$shared/models/XFile';
import { IconType } from '$shared/constants/IconType';

  interface Props {
    files: XFile[];
    onevent?: (payload: { type: string; data: string }) => void;
  }

  let { files, onevent }: Props = $props();

  const onClickFileRemove = (id: string): void => {
    onevent?.({ type: 'attach-removed', data: id });
  };
</script>

<div class="files" class:show={files.length !== 0}>
  {#each files as file}
    {#if file.name}
      <div class="file-li">
        <div class="icon">
          <Icon value="icon-file" />
        </div>
        <div class="label">{file.name}</div>
        <div class="delete-icon">
          <Icon
            name="cvo-popup-file-remove"
            value="icon-trash"
            type={IconType.Button}
            onclick={() => onClickFileRemove(file.id)}
          />
        </div>
      </div>
    {/if}
  {/each}
</div>

<style>
  .files {
    margin-top: 24px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    display: none;
    max-height: 200px;
    overflow: auto;
  }
  .files.show {
    display: block;
  }
  .file-li {
    display: flex;
    align-items: center;
    padding: 8px 16px;
  }
  .file-li:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }
  .file-li .icon {
    margin-right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .file-li .label {
    flex: 1;
  }

  .file-li .delete-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
</style>
